<template>
  <div class="px-4 mt-4 pb-4 duration-500 bg-white" >

    <p class="py-2 text-black">{{ t('history.title') }}</p>
    <v-data-table :headers="headers" :items="transactions" show-expand item-value="date" item-key="name" items-per-page="-1"
      totalItems="100" hide-default-footer id="tablecontainer"
      class="border h-full bg-gray text-black min-h-[500px]" style="font-size: 13px;" :style="`height: ${computedHeight}px;`">
      <template v-slot:expanded-row="{ columns, item }">
        <td :colspan="columns.length" class="border-b py-4">
          <div class="flex justify-center items-center">
            <div v-html="sanitizeTransactionDescription(item.description)">
            </div>
          </div>
        </td>
      </template>
      <template v-slot:[`item.address`]="{ item }">
        <div class="address-lines">
          <div v-for="(part, i) in (item.address || '').split(',')" :key="i" class="line">
            {{ part.trim() }}
          </div>
        </div>
      </template>
      <template v-slot:[`item.createdDate`]="{ item }">
        {{ formatDate(item.createdDate) }}
      </template>
      <template v-slot:[`item.checkbox`]="{  }">
      </template>
      <template #bottom></template>
    </v-data-table>
  </div>
</template>
<script setup>
import { t } from '@/i18n';

import { ref, computed, watchEffect, onMounted, onBeforeUnmount } from 'vue';
import { useBitcartStore } from '@/stores';
import { storeToRefs } from 'pinia';
import { sanitizeTransactionDescription } from '@/helpers/sanitize-html';
let count = 0;

const bitcartStore = useBitcartStore()
const payment = storeToRefs(bitcartStore)

const labelOf = (group, v) => { const k = String(v || '').toUpperCase(); const out = t(group + '.' + k); return out === group + '.' + k ? v : out; };
const headers = computed(() => 
  [
    { title: t('history.no'), align: 'center', key: 'no' },
    { title: t('history.created'), align: 'center', key: 'createdDate' },
    { title: t('history.type'), align: 'center', key: 'transactionType' },
    { title: t('history.status'), align: 'center', key: 'status' },
    { title: t('history.amount'), align: 'center', key: 'amount' },
    { title: t('history.paid'), align: 'center', key: 'amountCoin' },
    { title: t('history.hashes'), align: 'center', key: 'address' }
  ]
);
const offsetHeight = 500; // Adjust this value as needed

const computedHeight = ref(window.innerHeight - offsetHeight);

const handleResize = () => {
  computedHeight.value = window.innerHeight - offsetHeight;
};

onMounted(() => {
  window.addEventListener('resize', handleResize);

  count = 50;
  bitcartStore.loadTransactionHistory({from: 0, count: 50});
  const element = document.getElementById('tablecontainer').children[0]
  element.addEventListener('scroll', onScroll)
});

const onScroll = (event) => {
  const table = event.target;
  if (table.scrollTop + table.clientHeight >= table.scrollHeight) {
    bitcartStore.loadTransactionHistory({from: count, count: 20});
    count += 20;
  }
};

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
  const element = document.getElementById('tablecontainer').children[0]
  element.removeEventListener('scroll', onScroll)
});
const transactions = ref([...payment.transactions.value])
watchEffect(() => {
  transactions.value = [...payment.transactions.value].map((item, index) => {
    return {
      no: index + 1,
      createdDate: item.createdAt,
      transactionType: labelOf('history.types', item.type),
      status: labelOf('history.statuses', item.status),
      amount: String(Number(item.amount) + (item?.commission ? Number(item.commission) : 0) + (item?.costprice ? Number(item.costprice) : 0)) + item.currency,
      // Paid Amount is only for top-ups the customer paid themselves; every other row leaves the cell empty
      amountCoin: (String(item.type || '').toUpperCase() === 'TOPUP' && item.pay_amount !== null && item.pay_amount !== undefined && item.pay_amount !== '') ? String(item.pay_amount) + ' ' + (item.pay_currency || '') : '',
      address: item.pay_address === undefined ? '' : item.pay_address,
      date: item.updatedAt,
      description: item.description
    }
  })
}, [payment.transactions.value])

const formatDate = (date_m) => {
  const date = new Date(date_m);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${day}/${month}/${year}  ${hours}:${minutes}:${seconds}`;
}
// watchEffect(() => {
//   paymentStore.loadTransactionHistory()
// }, [])
</script>
